'use client';

import { VpIcon } from '@vtmn-play/react/headless';
import { useTranslations } from 'next-intl';
import { Link } from '@/i18n/routing';
import appConst from '~/const/appConst';
import { MainColumn } from '../commons/MainColumn/MainColumn';
import { journeyColumnTemplate } from '../Journey/config';

export const RewardsBanner = () => {
  const t = useTranslations('REWARDS.BANNER');

  return (
    <MainColumn column={journeyColumnTemplate}>
      <div
        className="rewards-banner"
        data-testid="rewards-banner"
      >
        <div className="rewards-banner__icon">
          <VpIcon name="gift" />
        </div>
        <div>
          <h2 className="vp-subtitle-m">
            {t('TITLE')}
          </h2>
          <p className="vp-caption">
            {t.rich('CONTENT', {
              link: chunks => (
                <Link
                  href={appConst.staticRoutes.rewards_terms}
                >
                  {chunks}
                </Link>
              ),
            })}
          </p>
        </div>
      </div>
    </MainColumn>
  );
};
